import { render, staticRenderFns } from "./InfiniteScrollTrigger.vue?vue&type=template&id=749edc9b&scoped=true"
import script from "./InfiniteScrollTrigger.vue?vue&type=script&lang=ts"
export * from "./InfiniteScrollTrigger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749edc9b",
  null
  
)

export default component.exports